import { Children, cloneElement, isValidElement, ReactElement, ReactNode, useEffect, useState } from 'react'
import { ArtboardLayerRef } from '../../types/refs'

type Layers = {
    nodes: ReactNode[]
    refs: ArtboardLayerRef[]
}

const useLayers = (children: ReactNode): Layers => {
    const [refs, setRefs] = useState<ArtboardLayerRef[]>([])
    const [nodes, setNodes] = useState<ReactNode[]>([])

    useEffect(() => {
        const layerRefs: ArtboardLayerRef[] = []
        const childNodes = Children.map(children, (child, i) => {
            if (isValidElement(child)) {
                return cloneElement(child as ReactElement, {
                    ref: (childRef: ArtboardLayerRef) => {
                        if (childRef && childRef.layerId) {
                            layerRefs[i] = childRef
                        }
                    },
                })
            }
            return child
        })

        setRefs(layerRefs)
        setNodes(childNodes || [])
    }, [children])

    return { nodes, refs }
}

export default useLayers
